import FormGroup from '@/ui-kit/components/form/entities/FormGroup';
import FormControl from '@/ui-kit/components/form/entities/FormControl';
import {
  requiredFormValidator,
  phoneFormValidator,
  timeFormValidator,
} from '@/ui-kit/components/form/validators';
import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';
import { ListingBookViewingFormControlName } from '../enums';
import { LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE } from '../constants';

export const dateControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.Date],
  [requiredFormValidator],
);

export const additionalDateControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.AdditionalDate],
  [requiredFormValidator],
);

export const startTimeControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.StartTime],
  [requiredFormValidator, timeFormValidator],
);

export const additionalStartTimeControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.AdditionalStartTime],
  [requiredFormValidator, timeFormValidator],
);

export const durationControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.Duration],
  [requiredFormValidator],
);

export const additionalDurationControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.AdditionalDuration],
  [requiredFormValidator],
);

export const phoneNumberControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.PhoneNumber],
  [requiredFormValidator, phoneFormValidator],
);

export const contactMethodControl = new FormControl(
  LISTING_BOOK_VIEWING_FORM_DEFAULT_VALUE[ListingBookViewingFormControlName.ContactMethod],
  [requiredFormValidator],
);

export const listingBookViewingFormGroup = new FormGroup(
  {
    [ListingBookViewingFormControlName.Date]: dateControl,
    [ListingBookViewingFormControlName.StartTime]: startTimeControl,
    [ListingBookViewingFormControlName.Duration]: durationControl,
    [ListingBookViewingFormControlName.PhoneNumber]: phoneNumberControl,
    [ListingBookViewingFormControlName.ContactMethod]: contactMethodControl,
  },
  [FormControlValidationStrategy.Change, FormControlValidationStrategy.Blur],
);
